/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/layouts/main-layout',['require','underscore','jquery','backbone','marionette','modernizr','core/layouts/fade-region','core/templates'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  var Modernizr = require('modernizr');
  var FadeRegion = require('core/layouts/fade-region');
  var templates = require('core/templates');

  /*****************************************************************************************************************///}

  var MainLayout = Marionette.LayoutView.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    el: '#genome',

    template: templates['core/layouts/main-layout'],

    events: {
      'click .navigation [data-action]': 'buttonPressed',
      'mouseover .navigation [data-action]': 'buttonOver',
      'mouseout .navigation [data-action]': 'buttonOut',
      //'click #achievement-alert-holder .achievement-alert-item': 'alertPressed'
    },

    regions: {
      pageHolder: {
        selector: '#page-holder',
        regionClass: FadeRegion
      },
      splash: '#splash',
      overlays: {
        selector: '#overlays',
        regionClass: FadeRegion
      }
    },

    viewport: null,
    alertHolder: null,
    radio: Backbone.Wreqr.radio.channel('global').vent,
    miniWait: null,
    achWait: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ////console.log('MainLayout::initialize');

      this.render();

      // have to call manually since this is the root
      this.onShow();
    },

    onShow: function()
    {
      this.viewport = this.$el.find('.genome-viewport');
      //this.alertHolder = this.viewport.find('#achievement-alert-holder');
      $(document).find('body').on('selectstart', function(e) {
        e.preventDefault();
        return false;
      });

      if (this.options.fullbleed)
      {
        //console.log('Content Mode: Full Bleed');
        this.viewport.addClass('fullbleed');
      }
      else
      {
        //console.log('Content Mode: Contained');
      }

      if (this.options.fullscreen)
      {
        //console.log('Display Mode: Fullscreen');
        this.viewport.addClass('fullscreen');
      }
      else
      {
        //console.log('Display Mode: Framed');
        this.viewport.addClass('framed');
        this.viewport.width(this.options.dimensions.width);
        this.viewport.height(this.options.dimensions.height);
        //this.viewport.css('margin-left', -this.options.dimensions.width / 2);
        //this.viewport.css('margin-top', -this.options.dimensions.height / 2);
      }

      this.radio.on('ui.update', $.proxy(this.updateUI, this));

      var self = this;
      this.pageHolder.on('show', function(view, region, options)
      {
        self.radio.trigger('page.changed', view); // use this event for any page changes throughout the course

        self.viewport.attr('data-layout', view.page.get('layout'));
        self.viewport.attr('data-page', view.page.get('id'));
      });

      this.splash.show(new Marionette.ItemView({ tagName: 'div', className: 'splash-content', template: templates['core/layouts/splash'] }));
    },

    begin: function()
    {
      var self = this;
      setTimeout(function()
      {
        self.splash.$el.hide();
      }, this.options.splashDdelay);
    },

    buttonPressed: function(e)
    {
      e.preventDefault();
      e.stopImmediatePropagation();
      var actionID = $(e.currentTarget).attr('data-action');
      $(e.currentTarget).blur();
      $(document).focus();

      //console.log('Button Pressed: ' + actionID);

      var eventStr = 'ui.button.pressed.' + actionID;
      this.radio.trigger(eventStr, e);
      return false;
    },

    buttonOver: function(e)
    {
      if (Modernizr.touch)
        return;
      $(e.currentTarget).addClass('over');
    },

    buttonOut: function(e)
    {
      $(e.currentTarget).removeClass('over');
    },

    /*alertPressed: function(e)
    {
      e.preventDefault();
      e.stopImmediatePropagation();

      var $alert = $(e.currentTarget);
      this.removeAlert($alert);
      return false;
    },

    removeAlert: function($alertItem)
    {
      $alertItem.stop().animate({opacity: 0}, {duration: 400, complete: function() {
        if (this.remove)
          this.remove();
        else
          $(this).remove();
      }});
    },*/

    /*showAchievement: function(achObj)
    {
      //var $earnedStr = ('You have earned the \"{{name}}\" achievement. Check it out by selecting the badge icon.').replace('{{name}}', achObj.title);
      if (this.achWait)
        return;

      this.achWait = setTimeout(function(self) {
        self.achWait = null;
      }, 500, this);
      var $earnedStr = ('Select the badge icon to check it out.');
      var $achItem = $('<div>').addClass('achievement-alert-item').attr('id', achObj.code);
      var $titleEl = $('<div>').addClass('alert-title').html('Achievement Earned!');
      var $bodyEl = $('<div>').addClass('alert-body').html($earnedStr);
      $achItem.append($titleEl);
      $achItem.append($bodyEl);

      //console.log('show achievement-alert-item', this.alertHolder, $achItem);
      this.alertHolder.append($achItem);

      $achItem.fadeIn();
      $achItem.css('bottom', $achItem.height() + 25);

      $achItem.animate({'a': 0}, {duration: 4000, complete: $.proxy(this.removeAlert, this, $achItem)});
    },*/

    /*showMinigameUnlock: function(minigamePage)
    {
      //var $earnedStr = ('Minigame \"{{name}}\" is now ulnocked!').replace('{{name}}', minigamePage.get('title'));
      if (this.miniWait)
        return;

      this.miniWait = setTimeout(function(self) {
        self.miniWait = null;
      }, 500, this);

      var $earnedStr = ('New game unlocked at the arcade.');
      var $achItem = $('<div>').addClass('minigame-alert-item achievement-alert-item').attr('id', minigamePage.get('id'));
      var $titleEl = $('<div>').addClass('alert-title').html('Arcade Update!');
      var $bodyEl = $('<div>').addClass('alert-body').html($earnedStr);
      $achItem.append($titleEl);
      $achItem.append($bodyEl);

      //console.log('show achievement-alert-item', this.alertHolder, $achItem);
      this.alertHolder.append($achItem);

      $achItem.fadeIn();
      $achItem.css('bottom', $achItem.height() + 25);

      $achItem.animate({'a': 0}, {duration: 4000, complete: $.proxy(this.removeAlert, this, $achItem)});
    },*/

    updateUI: function(object)
    {
      var viewport = this.viewport;
      viewport.find('.navigation [data-action]').removeClass('over');
      _.each(object, function(value, id)
      {
        viewport.find('[data-action=' + id + ']')
        .attr('disabled', !value)
        .toggleClass('disabled', !value);
      });
    }

  /*****************************************************************************************************************///}

  });

  return MainLayout;

});

